import { IndustryStyleTypes } from "API/Generated/IndustryStyleTypes";
import { Pageant } from "API/Generated/Pageant";
import { PageantRegionalTypes } from "API/Generated/PageantRegionalTypes";
import { AddDivisionsToAgeGroupRequest, DuplicatePageantRequest, EventDivision, EventDivisionBaseModel, EventDivisionModel, EventFeeTypeBaseModel, IndustryStyleTypeModel, PageantAgeGroupBaseModel, PageantAvailableEventModel, PageantAvailableTitleModel, PageantAwardTypeWinnersDto, PageantModel, PageantModelResponseWrapper, PageantRegionalTypeBaseModel, PageantRegistrationRequest, RegisteredPageantContestantModel } from "API/Generated/data-contracts";
import { action, makeObservable, observable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { RequestStatus } from "SessionState/RequestHandling/RequestStatus";
import { PageantRegistration } from "API/Generated/PageantRegistration";
import axios from 'axios';
import { PageantAvailableTitle } from "API/Generated/PageantAvailableTitle";
import { EventDivisions } from "API/Generated/EventDivisions";
import PageantAgeDivisions from "views/events/pageant/PageantAgeDivisions";
import { IAgeGroupValues } from "views/events/add/AddEditEvent";

interface Request {
    id: number;
    status: RequestStatus;
}




class PageantStore {
    PageantService: Pageant = new Pageant();
    EventDivisionService: EventDivisions = new EventDivisions();
    PageantRegionalTypesService: PageantRegionalTypes = new PageantRegionalTypes();
    IndustryStyleTypeService: IndustryStyleTypes = new IndustryStyleTypes();
    rules: string = '';
    details: string = '';
    PageantRegistration: PageantRegistration = new PageantRegistration();
    PageantAvailabeTitleService: PageantAvailableTitle = new PageantAvailableTitle();
    CurrentPageant: PageantModel;
    CurrentPageantRequest: Request = {
        id: 0,
        status: RequestStatus.PENDING
    };
    PageantRegionalTypeList: PageantRegionalTypeBaseModel[];
    IndustryStyleTypeList: IndustryStyleTypeModel[];
    EventFeeTypeList: EventFeeTypeBaseModel[] = [];

    PageantResults: PageantAwardTypeWinnersDto[] = [];
isLoadingPageantResults = false;
pageantResultsError: unknown = null;



    ShowTitleForm: boolean = false;
    AllowEdit: boolean = true;

    constructor(currentPageant: PageantModel, pageantRegionalTypeList: PageantRegionalTypeBaseModel[], industryStyleTypeList: IndustryStyleTypeModel[], eventFeeTypeList: EventFeeTypeBaseModel[], currentPageantRequest: Request, pageantResults: PageantAwardTypeWinnersDto[] ) {
        makeObservable(this, {
            CurrentPageant: observable,
            PageantRegionalTypeList: observable,
            IndustryStyleTypeList: observable,
            CurrentPageantRequest: observable,

              PageantResults: observable,
  isLoadingPageantResults: observable,
  pageantResultsError: observable,
  fetchPageantResults: action,
        })
        makePersistable(this, { name: 'PageantStore', properties: ['CurrentPageant', 'PageantRegionalTypeList', 'IndustryStyleTypeList'] });
        this.CurrentPageant = currentPageant;
        this.PageantRegionalTypeList = pageantRegionalTypeList;
        this.IndustryStyleTypeList = industryStyleTypeList;
        this.CurrentPageantRequest = currentPageantRequest;
        this.EventFeeTypeList = eventFeeTypeList;
        this.PageantResults = pageantResults;
    }

    setRules(rules: string) {
        this.rules = rules;
    }

    setDetails(details: string) {
        this.details = details;
    }

    async getPageantOrg(id: number, reset: boolean = false) {
        try {
            if (this.CurrentPageantRequest.id == id &&
                this.CurrentPageantRequest.status == RequestStatus.ACTIVE || this.CurrentPageantRequest.status == RequestStatus.COMPLETED
                && !reset) {
                return;
            }
            this.CurrentPageantRequest = { id: id, status: RequestStatus.ACTIVE };
            var pageantResult = await this.PageantService.getPageantById(id)
            // console.log("data", pageantResult);
            if (pageantResult.data.data) {
                this.CurrentPageantRequest.status = RequestStatus.COMPLETED;
                this.CurrentPageant = pageantResult?.data.data;
            }
        } catch (error) {
            this.CurrentPageantRequest.status = RequestStatus.ERROR;
            console.log("Error:" + JSON.stringify(error));
        }
    }

    async getPageant(id: number, reset: boolean = false) {
  try {
    if (
      this.CurrentPageantRequest.id === id &&
      (
        this.CurrentPageantRequest.status === RequestStatus.ACTIVE ||
        this.CurrentPageantRequest.status === RequestStatus.COMPLETED
      ) &&
      !reset
    ) {
      return;
    }

    this.CurrentPageantRequest = { id, status: RequestStatus.ACTIVE };

    const pageantResult = await this.PageantService.getPageantById(id);

    if (pageantResult.data.data) {
      this.CurrentPageant = pageantResult.data.data;
      this.CurrentPageantRequest.status = RequestStatus.COMPLETED;
    }
  } catch (error) {
    this.CurrentPageantRequest.status = RequestStatus.ERROR;
    console.log("Error:" + JSON.stringify(error));
  }
}

    //New fetch of basic pageant for nonusers - testing
    async getBasicPageant(id: number, reset: boolean = false) {
        try {
            if (this.CurrentPageantRequest.id == id &&
                this.CurrentPageantRequest.status == RequestStatus.ACTIVE || this.CurrentPageantRequest.status == RequestStatus.COMPLETED
                && !reset) {
                return;
            }
            this.CurrentPageantRequest = { id: id, status: RequestStatus.ACTIVE };
            var pageantResult = await this.PageantService.getPageantByIdNew(id)
            // console.log("data", pageantResult);
            if (pageantResult.data.data) {
                this.CurrentPageantRequest.status = RequestStatus.COMPLETED;
                this.CurrentPageant = pageantResult?.data.data;
            }
        } catch (error) {
            this.CurrentPageantRequest.status = RequestStatus.ERROR;
            console.log("Error:" + JSON.stringify(error));
        }
    }


    async getBasicPageantCompatOrg(pageantId: number, reset: boolean = false) {
        try {
            if (this.CurrentPageantRequest.id == pageantId &&
                this.CurrentPageantRequest.status == RequestStatus.ACTIVE || this.CurrentPageantRequest.status == RequestStatus.COMPLETED
                && !reset) {
                return;
            }
            this.CurrentPageantRequest = { id: pageantId, status: RequestStatus.ACTIVE };
            var pageantResult = await this.PageantService.publicDetailsDetail(pageantId)
            // console.log("data", pageantResult);
            if (pageantResult.data) {
                this.CurrentPageantRequest.status = RequestStatus.COMPLETED;
                this.CurrentPageant = pageantResult?.data;
            }
        } catch (error) {
            this.CurrentPageantRequest.status = RequestStatus.ERROR;
            console.log("Error:" + JSON.stringify(error));
        }
    }

async getBasicPageantCompat(pageantId: number, reset: boolean = false) {
  try {
    if (
      this.CurrentPageantRequest.id === pageantId &&
      (
        this.CurrentPageantRequest.status === RequestStatus.ACTIVE ||
        this.CurrentPageantRequest.status === RequestStatus.COMPLETED
      ) &&
      !reset
    ) {
      return;
    }

    this.CurrentPageantRequest = { id: pageantId, status: RequestStatus.ACTIVE };

    const pageantResult = await this.PageantService.publicDetailsDetail(pageantId);

    if (pageantResult.data) {
      this.CurrentPageant = pageantResult.data;
      this.CurrentPageantRequest.status = RequestStatus.COMPLETED;
    }
  } catch (error) {
    this.CurrentPageantRequest.status = RequestStatus.ERROR;
    console.log("Error:" + JSON.stringify(error));
  }
}

    async savePageant(model: PageantModel): Promise<boolean> {
        try {
            var pageantResult = await this.PageantService.addPageant(model);
            console.log("PageantResult", pageantResult);

            if (pageantResult.data.data) {
                this.CurrentPageant = pageantResult?.data.data;
                // Log the Age Groups and Division IDs after saving
                // console.log("Saved Pageant Age Groups Store:", this.CurrentPageant?.pageantAgeGroups);
                // this.CurrentPageant?.pageantAgeGroups?.forEach((ageGroup: any) => {
                //     console.log(`Age Group ID: ${ageGroup.id}, Division IDs: ${ageGroup.divisionIds} ${ageGroup.eventDivisions}`);
                // });

                return true;
            }
            return false;
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
            return false;
        }
    }

    // Assuming this is how the store method is defined:
    async getEventFeeTypes() {
        try {
            const result = await this.PageantService.getAllEventFeeTypes();  // Assuming this is your API call
            if (result.data.data) {
                this.EventFeeTypeList = result.data.data;
            }
            // Log the result before returning it
            console.info("Event fee types from store", result.data);

            // Return the data directly (assuming `data` contains the array of EventFeeTypes)
            return result.data;
        } catch (error) {
            console.error("Error fetching event fee types:", error);
            return []; // Return an empty array in case of error
        }
    }


    async savePageantSchedule(schedule: string): Promise<boolean> {
        try {
            var pageantToUpdate = { ...this.CurrentPageant, schedule: schedule }
            var pageantResult = await this.PageantService.addPageant(pageantToUpdate)

            if (pageantResult.data.data) {
                this.CurrentPageant = pageantResult?.data.data;
                return true;
            }
            return false;
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
            return false;
        }
    }





    async getPageantRegionalTypes() {
        try {
            if (this.PageantRegionalTypeList.length == 0) {
                var pageantRegionalTypeResult = await this.PageantRegionalTypesService.getPageantRegionalTypes()
                if (pageantRegionalTypeResult.data.data) {
                    this.PageantRegionalTypeList = pageantRegionalTypeResult.data.data
                }
            }
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
        }
    }

    async getIndustryStyleTypes() {
        try {
            if (this.IndustryStyleTypeList.length == 0) {
                var industryStyleTypeResult = await this.IndustryStyleTypeService.getAllIndustryStyleTypes()
                if (industryStyleTypeResult.data) {
                    this.IndustryStyleTypeList = industryStyleTypeResult.data
                }
            }
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
        }
    }

    async beginScoringProcess(pageantId) {
        try {
            const result = await this.PageantService.beginScoringProcess(pageantId);
            return result?.data;
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
        }
    }

//===================GET PAGEANT RESULTS - start====================
async fetchPageantResults(pageantId: number): Promise<PageantAwardTypeWinnersDto[]> {
  this.isLoadingPageantResults = true;
  this.pageantResultsError = null;

  try {
    const result = await this.PageantService.resultsDetail(pageantId);
    const results = result?.data ?? [];

    runInAction(() => {
      this.PageantResults = results;
    });

    return results;
  } catch (error: unknown) {
    runInAction(() => {
      this.pageantResultsError = error;
      this.PageantResults = [];
    });

    console.error("Error fetching pageant results", error);
    return [];
  } finally {
    runInAction(() => {
      this.isLoadingPageantResults = false;
    });
  }
}
//===================GET PAGEANT RESULTS - end====================


    async saveEventDivision(model: EventDivisionModel): Promise<EventDivisionModel | null> {
        try {
            // Only include genderId and compStyleId if they are provided (i.e., if they are not undefined)
            const updatedModel = {
                ...model,
                // Only include genderId and compStyleId if they are provided (i.e., if they are not undefined)
                genderId: model.genderId !== undefined ? model.genderId : undefined,
                compStyleId: model.compStyleId !== undefined ? model.compStyleId : undefined,
                description: model.description || "No description provided",  // Default description if not provided
                PageantAgeGroupIds: model.pageantAgeGroupIds || [],
                PageantIds: model.pageantIds || [],
            };


            // Check if a division with the same name, genderId, and compStyleId already exists and has no custom description
            const existingDivision = this.CurrentPageant?.eventDivisions?.find(
                (div) =>
                    div.name?.toLowerCase() === updatedModel.name?.toLowerCase() &&
                    div.genderId === updatedModel.genderId &&
                    div.compStyleId === updatedModel.compStyleId &&
                    div.availableToEveryone === true &&  // Only if it's available to everyone
                    div.description === "No description provided"  // Ensure it hasn't been custom set
            );

            if (existingDivision) {
                // If a matching division exists and no custom description, return the existing division
                console.log("Division already exists:", existingDivision);
                return existingDivision;
            }

            // If no existing division or custom description provided, create it in the DB
            const divisionResult = await this.EventDivisionService.eventDivisionsCreate(updatedModel);

            if (divisionResult?.data) {
                // Add the new division to the pageant's divisions list
                this.CurrentPageant.eventDivisions?.push(divisionResult.data);
                console.log("New division created:", divisionResult.data);
                return divisionResult.data;
            }

            return null;
        } catch (error) {
            console.error("Error saving division:", error);
            return null;
        }
    }



    async updateDivisionsForAgeGroup(ageGroupId: number, divisionIds: number[]) {
        try {
            // Prepare the request object with the age group ID and division IDs
            const request: AddDivisionsToAgeGroupRequest = {
                ageGroupId: ageGroupId,   // The ID of the age group you're updating
                divisionIds: divisionIds  // List of selected divisions for that age group
            };

            // Make the API call to update the divisions for the specified age group
            const response = await this.EventDivisionService.addDivisionsToAgeGroupCreate(request);

            // Check if the response is successful
            if (response.status === 200) {
                console.log("Divisions successfully updated.");
                return response.data;
            } else {
                console.error("Failed to update divisions for the Age Group.", response.data);
                return null;
            }
        } catch (error) {
            console.error("Error updating divisions for Age Group", error);
            throw error;  // Propagate the error so it can be handled by the UI
        }
    }



    async saveAllAgeGroupDivisions(ageGroupsLocal: IAgeGroupValues[]) {
        try {
            console.log("Starting the process of saving divisions for all age groups...");

            const validAgeGroups = ageGroupsLocal.filter((ageGroup) => {
                const hasValidDivisions = Array.isArray(ageGroup.divisionIds) && ageGroup.divisionIds.length > 0;
                if (!hasValidDivisions) {
                    console.log(`Skipping Age Group ID ${ageGroup.id} as no divisions are selected.`);
                    return false;
                }
                // console.log(`Age Group ID: ${ageGroup.id}`);
                // console.log(`Start Age: ${ageGroup.startAge}, End Age: ${ageGroup.endAge}`);
                // console.log(`Selected Divisions for this Age Group: ${ageGroup.divisionIds}`);
                return true;
            });

            if (validAgeGroups.length === 0) {
                console.log("No valid age groups with divisions selected. Skipping save operation.");
                return;
            }

            const requests = validAgeGroups.map((ageGroup) => {
                const existingDivisions = (ageGroup.eventDivisions ?? [])
                    .map((division) => division.id)
                    .filter((id): id is number => typeof id === 'number');

                const divisionsToAdd = ageGroup.divisionIds.filter((id) => !existingDivisions.includes(id));
                const divisionsToRemove = existingDivisions.filter((id) => !ageGroup.divisionIds.includes(id));

                return {
                    AgeGroupId: ageGroup.id,
                    DivisionsToAdd: divisionsToAdd,
                    DivisionsToRemove: divisionsToRemove,
                };
            });

            // console.log("Divisions to Add and Remove for each Age Group:");
            // requests.forEach((request) => {
            //     console.log(`Age Group ID: ${request.AgeGroupId}`);
            //     console.log(`Divisions to Add: ${request.DivisionsToAdd}`);
            //     console.log(`Divisions to Remove: ${request.DivisionsToRemove}`);
            // });

            // ✅ Process adds and removals
            for (const request of requests) {
                if (request.DivisionsToAdd.length > 0) {
                    const addResponse = await this.EventDivisionService.addDivisionsToAgeGroupCreate({
                        ageGroupId: request.AgeGroupId,
                        divisionIds: request.DivisionsToAdd,
                    });
                    if (addResponse.status !== 200) {
                        console.error(`Failed to add divisions for Age Group ID ${request.AgeGroupId}`);
                    }
                }

                if (request.DivisionsToRemove.length > 0) {
                    for (const divisionId of request.DivisionsToRemove) {
                        const removeResponse = await this.EventDivisionService.removeDivisionFromAgegroupCreate({
                            ageGroupId: request.AgeGroupId,
                            divisionId: divisionId,
                        });
                        if (removeResponse.status !== 200) {
                            console.error(`Failed to remove division ${divisionId} from Age Group ID ${request.AgeGroupId}`);
                        }
                    }
                }
            }

            console.log("Divisions successfully updated for all valid age groups.");
        } catch (error) {
            console.error("❌ Error saving all divisions for age groups", error);
            throw error;
        }
    }

    async addDivisionToPageant(pageantId: number, divisionId: number): Promise<boolean> {
        try {
            const { status } = await this.EventDivisionService.addDivisionsToPageantCreate({
                pageantId,
                divisionIds: [divisionId],
            });

            return status === 200;
        } catch (error) {
            console.error("Error linking division to pageant:", error);
            return false;
        }
    }

    async removeDivisionFromPageant(request: { pageantId: number; divisionId: number }): Promise<boolean> {
        try {
            const response = await this.EventDivisionService.removeDivisionFromPageantCreate(request);
            return response.status === 200;
        } catch (error) {
            console.error('Error removing division from pageant:', error);
            return false;
        }
    }

    async saveAgeGroups(pageantId: number, ageGroupsPayload: any[]): Promise<void> {
        try {
            const response = await this.PageantService.saveAgeGroupsCreate(pageantId, ageGroupsPayload);

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to save age groups');
            }
            // 🔁 Update state
            await this.refreshCurrentPageant();

            console.info('✅ Age groups saved and updated in store');
        } catch (error) {
            console.error('❌ Error saving age groups:', error);
            throw error;
        }
    }

    async deleteAgeGroups(pageantId: number, ageGroupIds: number[]): Promise<void> {
        try {
            const response = await this.PageantService.deleteAgeGroupsCreate(pageantId, ageGroupIds); // ✅ Pass plain array

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to delete age groups');
            }

            await this.refreshCurrentPageant(); // 🔁 Sync state

            console.info('✅ Age groups deleted and updated in store');
        } catch (error) {
            console.error('❌ Error deleting age groups:', error);
            throw error;
        }
    }



    async checkExistingOrAddNewEventDivision(model: EventDivisionModel): Promise<EventDivisionModel | null> {
        try {
            // Attempt to find or create the event division
            const response = await this.EventDivisionService.findExistingOrCreateNewCreate(model);

            // Check if the response contains valid data
            if (response && response.data) {
                return response.data; // Return the division data if it's valid
            }

            // If no valid data, return null
            return null;
        } catch (error) {
            // Log error if something goes wrong and return null
            console.error("Error checking or adding event division:", error);
            return null;
        }
    }

    async getAllEventDivisions(): Promise<EventDivisionModel[]> {
        try {
            const response = await this.EventDivisionService.getAllList();

            // Handle the response data (assuming it's an array of event divisions)
            return response.data || []; // Return empty array if no data
        } catch (error) {
            console.error('Error fetching event divisions:', error);
            return []; // Return empty array if there's an error
        }
    }

    async getAllPageantDivisions(pageantId): Promise<EventDivisionModel[]> {
        try {
            const response = await this.EventDivisionService.byPageantDetail(pageantId);

            // Handle the response data (assuming it's an array of event divisions)
            return response.data || []; // Return empty array if no data
        } catch (error) {
            console.error('Error fetching event divisions for pageant:', error);
            return []; // Return empty array if there's an error
        }
    }


    async recalculateAllContestantsAgeAndSupremeGroups() {
        const contestants = this.CurrentPageant?.registeredPageantContestants ?? [];

        for (const reg of contestants) {
            try {
                await this.PageantRegistration.calculateAndAssignAgeAndSuprmeGroups({
                    pageantRegistrationId: reg.id ?? 0,
                });
            } catch (err) {
                console.error(`❌ Error recalculating for contestant ID: ${reg.id}`, err);
            }
        }

        console.log("✅ Finished recalculating all age and supreme groups.");
    }





    async refreshCurrentPageant() {
        if (this.CurrentPageant.id) {
            await this.getPageant(this.CurrentPageant.id, true);
        }
    }




    async getRegistration(id: number): Promise<RegisteredPageantContestantModel | undefined> {
        try {
            const registrationResult = await this.PageantRegistration.getPageantRegistrationById(id);
            return registrationResult?.data?.data;
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
        }
    }

    async getPageantContestants(pageantId: number): Promise<RegisteredPageantContestantModel[]> {
        try {
            const response = await this.PageantService.getPageantById(pageantId);
            if (response?.data?.data?.registeredPageantContestants) {
                // Assuming registeredPageantContestants includes contestantUser and contestantUser includes userId
                return response.data.data.registeredPageantContestants.map(contestant => ({
                    ...contestant,
                    contestantUser: {
                        ...contestant.contestantUser,
                        user: response.data.data?.registeredPageantContestants?.find(user => user.id === contestant?.contestantUser?.userId)
                    }
                }));
            }
            return [];
        } catch (error) {
            console.log("Error: " + JSON.stringify(error));
            return [];
        }
    }

    async refreshCurrentRegistration(Request: PageantRegistrationRequest) {
        const registeredContestants = this.CurrentPageant?.registeredPageantContestants ?? [];
        const registeredContestant = registeredContestants.find(x => x.id == Request?.pageantRegistrationModel?.id);

        if (registeredContestant?.id) {
            const result = await this.getRegistration(registeredContestant.id);
            if (result) {
                const index = registeredContestants.indexOf(registeredContestant);
                if (index !== -1) {
                    registeredContestants[index] = result;
                }
            }
        }
    }






    async resetCurrentPageant() {
        // this.CurrentPageant = {};
        this.CurrentPageantRequest = { id: 0, status: RequestStatus.PENDING };
    }

    async showTitleForm() {
        this.ShowTitleForm = true;
    }
    async hideTitleForm() {
        this.ShowTitleForm = false;
    }
    async setAllowEdit(allowEdit: boolean) {
        this.AllowEdit = allowEdit;
    }



    async updatePageantAward(item: PageantAvailableTitleModel) {
        if (this.CurrentPageant.pageantAvailableTitles != undefined) {
            this.CurrentPageant.pageantAvailableTitles = this.CurrentPageant.pageantAvailableTitles?.filter(x => x.id != item.id)
            this.CurrentPageant.pageantAvailableTitles = [...this.CurrentPageant.pageantAvailableTitles, item]
        }
    }



    async updatePageantAOC(item: PageantAvailableEventModel) {
        if (this.CurrentPageant.pageantAvailableAOC != undefined) {
            this.CurrentPageant.pageantAvailableAOC = this.CurrentPageant.pageantAvailableAOC?.filter(x => x.id != item.id)
            this.CurrentPageant.pageantAvailableAOC = [...this.CurrentPageant.pageantAvailableAOC, item]
        }
    }




    //=======================DUPLICATE THINGS FROM OTHER PAGEANTS START==========================
    // Method to duplicate pageant packages
    async duplicatePackagesFromPageant(existingPageantId: number, newPageantId: number) {
        try {
            // Create an object with the existingPageantId and newPageantId
            const pageantIds = { existingPageantId, newPageantId };

            // Call the service method to duplicate Packages
            const result = await this.PageantService.duplicatePageantPackages(pageantIds);

            // Handle the result, you can store the duplicated age groups if needed
            console.log('Duplicated Packages:', result);

            // Return result (optional)
            return result;
        } catch (error) {
            console.error('Error duplicating Packages:', error);
        }
    }

    async duplicateAOCFromPageant(existingPageantId: number, newPageantId: number) {
        try {
            // Create an object with the existingPageantId and newPageantId
            const pageantIds = { existingPageantId, newPageantId };

            // Call the service method to duplicate AOC
            const result = await this.PageantService.duplicatePageantAoc(pageantIds);

            // Handle the result, you can store the duplicated AOC if needed
            console.log('Duplicated AOC:', result);

            // Return result (optional)
            return result;
        } catch (error) {
            console.error('Error duplicating AOC:', error);
        }
    }

    async duplicateAwardsFromPageant(existingPageantId: number, newPageantId: number) {
        try {
            // Create an object with the existingPageantId and newPageantId
            const pageantIds = { existingPageantId, newPageantId };

            // Call the service method to duplicate awards
            const result = await this.PageantService.duplicatePageantAwards(pageantIds);

            // Handle the result, you can store the duplicated awards if needed
            console.log('Duplicated awards:', result);

            // Return result (optional)
            return result;
        } catch (error) {
            console.error('Error duplicating awards:', error);
        }
    }




    // Store method to duplicate age divisions
    async duplicateAgeDivisionsFromPageant(existingPageantId: number, newPageantId: number) {
        try {
            // Create an object with the existingPageantId and newPageantId
            const pageantIds = { existingPageantId, newPageantId };

            // Call the service method to duplicate age divisions
            const result = await this.PageantService.duplicateAgeGroupsAndDivisions(pageantIds);

            // Handle the result, you can store the duplicated age groups if needed
            console.log('Duplicated Age Divisions:', result);

            // Return result (optional)
            return result;
        } catch (error) {
            console.error('Error duplicating age divisions:', error);
        }
    }

    async duplicateEntirePageant(request: DuplicatePageantRequest) {
        try {
            // IMPORTANT: endpoint is now [FromBody], so send the full request object
            const response = await this.PageantService.duplicatePageant(request);

            // Most generated clients put your ResponseWrapper in response.data
            const wrapper = response.data;

            console.log('duplicate wrapper:', wrapper);

            if (!wrapper || !wrapper.isSuccessful || !wrapper.data) {
                console.error('Duplicate failed:', wrapper?.exception);
                return null;
            }

            // keep state in sync
            this.CurrentPageant = wrapper.data;

            return wrapper.data;
        } catch (error) {
            console.error('Error duplicating pageant:', error);
            return null;
        }
    }




    //=======================DUPLICATE THINGS FROM OTHER PAGEANTS END==========================



}

let pageantStore: PageantStore;

export function GetPageantStore() {
    if (!pageantStore) {
        pageantStore = new PageantStore({}, [], [], [], { id: 0, status: RequestStatus.PENDING }, []);
    }
    return pageantStore;
}